import React from "react";

import { Button, Input, TextValidations } from "../../../Components";
import {
  InputsContainer,
  ContainerValidations,
} from "../ForgotPassword.styled";

export interface PasswordScreenI {
  variables: {
    newPassword?: string;
    confirmPassword?: string;
    loading?: boolean;
    enable?: boolean;
    visibleNewPassword?: boolean;
    visibleConfirmPassword?: boolean;
  };
  actions: {
    onChangePassword: (e: any, type: "newPassword" | "confirmPassword") => void;
    onSubmit: () => void;
    toggleVisibility: (type: "newPassword" | "confirmPassword") => void;
  };
}

export const PasswordScreen: React.FC<PasswordScreenI> = ({
  actions,
  variables,
}) => {
  return (
    <div>
      <InputsContainer>
        <Input
          placeholder="Nova senha"
          style={{ paddingBottom: 16 }}
          filled={"true"}
          toggleVisible={() => actions.toggleVisibility("newPassword")}
          securityText={variables?.visibleNewPassword || false}
          onChange={(e) =>
            actions.onChangePassword(e.target.value, "newPassword")
          }
          value={variables?.newPassword}
          maxLength={8}
        />
        <Input
          placeholder="Confirmar senha"
          style={{ paddingBottom: 16 }}
          filled={"true"}
          toggleVisible={() => actions.toggleVisibility("confirmPassword")}
          securityText={variables?.visibleConfirmPassword || false}
          onChange={(e) =>
            actions.onChangePassword(e.target.value, "confirmPassword")
          }
          value={variables?.confirmPassword}
          maxLength={8}
        />
      </InputsContainer>

      <ContainerValidations>
        <TextValidations
          {...{
            value: variables.newPassword || "",
            valueConfirm: variables.confirmPassword,
          }}
        />
      </ContainerValidations>

      <div style={{ paddingBottom: 24, marginTop: 22 }}>
        <Button
          style={{ width: "100%" }}
          onClick={actions.onSubmit}
          loading={variables.loading}
          disabled={!variables.enable}
        >
          Continuar
        </Button>
      </div>
    </div>
  );
};
